<template>
  <div class="container-fluid p-4">
    <DetailTop v-if="detailTop" :detailTop="detailTop" />

    <div class="d-flex flex-between my-3">
      <h4 class="text-uppercase mb-0">data rawat jalan</h4>
    </div>
    <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
      <div class="col-md-7 pr-1" v-if="detailLeftTop">
        <DetailLeft :detailLeftTop="detailLeftTop" />
      </div>
      <div class="col-md-5 pl-1" v-if="detailRightTop">
        <DetailRight :detailRightTop="detailRightTop" />
      </div>
    </div>

    <div v-if="status != 'DIBATALKAN'">
      <div class="row mb-3">
        <div class="col-md-12">
          <div>
            <div class="d-flex flex-between my-3">
              <h4 class="text-uppercase mb-0">hasil pemeriksaan</h4>
            </div>
            <div class="d-flex flex-between my-3">
              <h5 class="mb-2">Hasil Pemeriksaan perawat</h5>
            </div>
            <div class="row mb-4" v-if="dataPetugasLeft || dataPetugasRight">
              <div class="col-md-7 pr-1">
                <DetailLeft :detailLeftTop="dataPetugasLeft" />
              </div>
              <div class="col-md-5 pl-1">
                <DetailRight :detailRightTop="dataPetugasRight" />
              </div>
            </div>
            <EmptyState v-else :data="emptyPtg" />
            <div class="d-flex flex-between my-3">
              <h5 class="mb-2">Hasil Pemeriksaan Ophthalmic</h5>
            </div>
            <div class="row mb-4" v-if="dataOphthalmic">
              <div class="col-md-12">
                <DetailLeft
                  v-if="dataOphthalmic"
                  :detailLeftTop="dataOphthalmic"
                />
                <TabelOphthalmicDisabled
                  v-if="dataTabelOphthalmic"
                  :data="dataTabelOphthalmic"
                />
              </div>
            </div>
            <EmptyState v-else :data="emptyOph" />
            <div class="d-flex flex-between my-3">
              <h5 class="mb-2">Hasil Pemeriksaan Dokter</h5>
            </div>
            <div class="row mb-4" v-if="dataDokterLeft || dataDokterRight">
              <div class="col-md-6">
                <DetailRight :detailRightTop="dataDokterLeft" />
              </div>
              <div class="col-md-6">
                <DetailRight :detailRightTop="dataDokterRight" />
              </div>
            </div>
            <EmptyState v-else :data="emptyDok" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import EmptyState from "@/components/EmptyState.vue";
import TabelOphthalmicDisabled from "@/components/TabelOphthalmicDisabled.vue";
// import { HTTP } from "@/config.js";
import { data, longText, tabs } from "@/data/RalanDetail.js";
import {
  setPatientIntro,
  setPeriksaPetugas,
  setPeriksaDokter,
  setPeriksaOphthalmic,
} from "@/data/helper.js";

export default {
  name: "RalanDetail",
  components: {
    DetailTop,
    DetailLeft,
    DetailRight,
    TabelOphthalmicDisabled,
    EmptyState,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        "SEDANG DIPERIKSA": "secondary",
        SELESAI: "success",
        "MENUNGGU PEMBAYARAN": "warning",
        "SELESAI DIPERIKSA": "info",
      },
      test: "hahaha",
      id_ralan: "",
      status: "",
      data: data,
      longText: longText,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      detailBottom: null,
      detailApproval: null,
      dataPetugasLeft: null,
      dataPetugasRight: null,
      dataOphthalmic: null,
      dataTabelOphthalmic: null,
      dataDokterLeft: null,
      dataDokterRight: null,
      tabs: tabs,
      emptyPtg: {
        img: "/img/nurse.svg",
        title: "Belum Ada Pemeriksaan Perawat",
        content:
          "Isi data pemeriksaan perawat dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ralan/form-petugas/" + this.$route.params.id,
        label: "Input Pemeriksaan Perawat",
      },
      emptyOph: {
        img: "/img/oph.svg",
        title: "Belum ada pemeriksaan ophthalmic",
        content:
          "Isi data pemeriksaan ophthalmic dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ralan/form-ophthalmic/" + this.$route.params.id,
        label: "Input Pemeriksaan Ophthalmic",
      },
      emptyDok: {
        img: "/img/doctor.svg",
        title: "Belum ada pemeriksaan dokter",
        content:
          "Isi data pemeriksaan dokter dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ralan/form-dokter/" + this.$route.params.id,
        label: "Input Pemeriksaan Dokter",
      },
      emptyTindakan: {
        img: "/img/nurse.svg",
        title: "Belum ada data tindakan",
        content: "Isi data tindakan dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyLab: {
        img: "/img/lab.svg",
        title: "Belum ada data",
        content:
          "Isi data pemeriksaan lab dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyObat: {
        img: "/img/med.svg",
        title: "Belum ada resep obat",
        content: "Input resep obat dengan mengeklik tombol Ubah Resep Obat",
        size: "small",
        link: "",
        label: "",
      },
      emptyOptik: {
        img: "/img/opt.svg",
        title: "Belum ada resep optik",
        content: "Input resep optik dengan mengeklik tombol Ubah Resep Optik",
        size: "small",
        link: "",
        label: "",
      },
      metodeBayar: ["Umum", "BPJS", "Asuransi Lain"],
      resiko: [
        "Rendah",
        "Rendah",
        "Rendah",
        "Rendah",
        "Sedang",
        "Sedang",
        "Sedang",
        "Sedang",
        "Tinggi",
        "Tinggi",
        "Tinggi",
      ],
      tabActive: "pemeriksaan",
      formSet: {
        id_petugas: "",
        id_petugas_lab: "",
        id_dokter: "",
        lab_type: "",
      },
      doc: [],
      nrs: [],
      both: [],
      lab: [],
      obat: [],
      optik: [],
      resepOptik: null,
    };
  },
  methods: {
    // activateTab(tab) {
    //   this.tabActive = tab.link;
    //   this.tabs = this.tabs.map(item => {
    //     if (item.active) {
    //       item.active = false;
    //     }
    //     if (tab.link == item.link) {
    //       item.active = true;
    //     }
    //     return item;
    //   });
    // },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/${this.$route.params.id}?darurat=0`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          let ralan = result.data;
          if (ralan.asal_rujukan) {
            let faskes = await this.$store.state.HTTP.get(
              `faskes/${ralan.asal_rujukan}`
            );
            if (faskes.status == "200") {
              ralan.asal_rujukan_formatted = faskes.data.nama;
            }
          }
          this.status = ralan.status;
          this.$set(this.data, "actionBtn", [
            {
              type: "status",
              className: `badge-${this.classes[this.status]}`,
              label: this.status,
            },
          ]);
          this.id_ralan = ralan.id;
          //console.log(ralan);
          this.detailTop = setPatientIntro(dataPasien);
          //console.log(this.detailTop);
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                },
                {
                  label: "Tanggal/Waktu Periksa",
                  content: ralan.formatted_tgl_jam_periksa,
                  icon: "access_time",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Unit",
                  content: ralan.unit.nama,
                  icon: "label_outline",
                },
                {
                  label: "Jenis Periksa",
                  content: ralan.jen_periksa,
                  icon: "filter_center_focus",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Dokter yang Dituju",
                  content: ralan.dokter.formatted_nama,
                  icon: "person_pin",
                },
                {
                  label: "Status",
                  content: ralan.status,
                  icon: "check_circle",
                },
              ],
            },
          ];

          this.detailRightTop = [
            {
              label: "Metode Pembayaran",
              content: this.metodeBayar[parseInt(ralan.id_asuransi) - 1],
              icon: "payment",
            },
            {
              label: `Nomor Peserta ${
                this.metodeBayar[parseInt(ralan.id_asuransi) - 1]
              }`,
              content: ralan.no_peserta || "-",
              icon: "contacts",
            },
            {
              label: "Asal Rujukan",
              content: ralan.dirujuk
                ? ralan.asal_rujukan_formatted
                : "Tanpa Rujukan",
              icon: "rotate_right",
            },
          ];
          //console.log(this.detailRightTop);
          if (ralan.rln_periksa_ptg) {
            let dataPetugas = setPeriksaPetugas(ralan.rln_periksa_ptg);
            //console.log(setPeriksaPetugas(ralan.rln_periksa_ptg));
            //console.log(dataPetugas);
            this.dataPetugasLeft = dataPetugas.left;
            this.dataPetugasRight = dataPetugas.right;
          }
          if (ralan.rln_periksa_dok) {
            //console.log(ralan);
            //console.log(ralan.rln_periksa_dok);
            let result = await this.$store.state.HTTP.get(
              `ralan/pemeriksaan/dokter/${ralan.rln_periksa_dok.id}`
            );
            //console.log(result);
            ralan.rln_periksa_dok.rln_periksa_dok_penyakit =
              result.data.rln_periksa_dok_penyakit;
            let dataDokter = setPeriksaDokter(ralan.rln_periksa_dok);
            //console.log(dataDokter);
            this.dataDokterLeft = dataDokter.left;
            this.dataDokterRight = dataDokter.right;
          }
          if (ralan.rln_periksa_oph) {
            this.dataOphthalmic = setPeriksaOphthalmic(ralan.rln_periksa_oph);
            this.dataTabelOphthalmic = ralan.rln_periksa_oph;
            //console.log(this.dataOphthalmic);
          }
          this.fetchTindakan(ralan.no_rawat);
          this.fetchLab(ralan.no_rawat);
          this.fetchObat(ralan.no_rawat);
          this.fetchOptik(ralan.no_rawat);
          this.fetchResepOptik(ralan.no_rawat);
          this.print();
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    fetchObat: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/obat?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchOptik: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/barang/optik?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_optik = item.id;
            item.id = item.optik.id;
            item.kode = item.optik.kode;
            item.nama = item.optik.nama;
            item.jenis = item.optik.jenis;
            item.lokasi = item.optik.lokasi;
            self.optik.push(item);
          });
          self.optik = self.optik.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchResepOptik: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/optik?no_rawat=${no_rawat}`
        );
        //console.log(result);
        // let self=this;
        if (result.status == "200") {
          //console.log('resep-optik');
          //console.log(result);
          //console.log('resep-optik');
          if (result.data) {
            this.resepOptik = result.data;
            //console.log(this.resepOptik);
            this.resepOptik.id_resep = this.resepOptik.id;
          }
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchTindakan: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/tindakan/penanganan?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          let tindDoc = result.data.penanganan_dokter;
          tindDoc.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.doc = self.doc.concat(item);
          });
          let tindBoth = result.data.penanganan_dokter_petugas;
          tindBoth.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.both = self.both.concat(item);
          });
          let tindNrs = result.data.penanganan_petugas;
          tindNrs.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            // self.nrs.push(item);
            self.nrs = self.nrs.concat(item);
          });
          if (tindBoth.length) {
            self.formSet.id_petugas = String(tindBoth[0].id_petugas);
            self.formSet.id_dokter = String(tindBoth[0].id_dokter);
          } else {
            if (tindNrs.length) {
              self.formSet.id_petugas = String(tindNrs[0].id_petugas);
            }
            if (tindDoc.length) {
              self.formSet.id_dokter = String(tindDoc[0].id_dokter);
            }
          }
          //console.log(self);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchLab: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/lab?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          self.lab = [];
          result.data.data
            .filter((item) => item.status != "DIBATALKAN")
            .forEach((item) => {
              item.nama = item.periksalab.nama;
              item.kode = item.periksalab.kode;
              item.id_ralan_lab = item.id;
              item.id = item.periksalab.id;
              self.lab = self.lab.concat(item);
            });
          if (result.data.data.length) {
            self.formSet.id_petugas_lab = String(
              result.data.data[0].id_petugas
            );

            self.formSet.lab_type = result.data.data[0].kategori;
          }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    print: async function() {
      setTimeout(function() {
        window.print();
      }, 1000);
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.displayData();
  },
};
</script>
